var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgLeaveChatIcon = function SvgLeaveChatIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    role: "presentation",
    "aria-hidden": true,
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.9084252,
    d: "M9.904 2.483a.453.453 0 0 1 0 .906c-1.212 0-2.089 0-2.774.066-.677.065-1.119.192-1.475.414-.41.256-.756.602-1.012 1.012-.222.356-.348.798-.414 1.476-.066.684-.066 1.56-.066 2.772v4.818c0 1.211 0 2.088.066 2.772.066.678.192 1.12.414 1.476.256.41.602.756 1.012 1.012.356.222.798.349 1.475.414.685.066 1.562.066 2.774.066a.454.454 0 0 1 0 .906c-1.194 0-2.122 0-2.86-.07-.745-.072-1.344-.22-1.868-.547a4.1 4.1 0 0 1-1.301-1.302c-.327-.523-.475-1.123-.547-1.868-.071-.738-.07-1.666-.07-2.86V9.13c0-1.193-.001-2.121.07-2.86.072-.744.22-1.344.547-1.868a4.1 4.1 0 0 1 1.3-1.3c.525-.327 1.124-.476 1.869-.547.738-.072 1.666-.071 2.86-.071Zm4.82 3.93a.453.453 0 0 1 .638.056l3.997 4.779c.14.168.14.413 0 .581l-3.997 4.779a.453.453 0 0 1-.694-.581l3.375-4.036H7.535a.453.453 0 0 1 0-.906h10.508L14.668 7.05a.453.453 0 0 1 .057-.638Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLeaveChatIcon);
export { ForwardRef as Icon };
export default "customIcons/leave-chat-icon.ac05702.svg";